var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewScans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21071_258964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_21071_258964)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2058 14.625L11.7808 13.675L13.3558 14.6375L12.9433 12.8375L14.3308 11.6375L12.5058 11.475L11.7808 9.775L11.0558 11.4625L9.23077 11.625L10.6183 12.8375L10.2058 14.625ZM11.7808 14.85L9.70577 16.1C9.6141 16.1583 9.51827 16.1833 9.41827 16.175C9.31827 16.1667 9.23077 16.1333 9.15577 16.075C9.08077 16.0167 9.02244 15.9437 8.98077 15.8562C8.9391 15.7687 8.93077 15.6708 8.95577 15.5625L9.50577 13.2L7.66827 11.6125C7.58494 11.5375 7.53285 11.4521 7.51202 11.3562C7.49119 11.2604 7.49744 11.1667 7.53077 11.075C7.5641 10.9833 7.6141 10.9083 7.68077 10.85C7.74744 10.7917 7.8391 10.7542 7.95577 10.7375L10.3808 10.525L11.3183 8.3C11.3599 8.2 11.4245 8.125 11.512 8.075C11.5995 8.025 11.6891 8 11.7808 8C11.8724 8 11.962 8.025 12.0495 8.075C12.137 8.125 12.2016 8.2 12.2433 8.3L13.1808 10.525L15.6058 10.7375C15.7224 10.7542 15.8141 10.7917 15.8808 10.85C15.9474 10.9083 15.9974 10.9833 16.0308 11.075C16.0641 11.1667 16.0704 11.2604 16.0495 11.3562C16.0287 11.4521 15.9766 11.5375 15.8933 11.6125L14.0558 13.2L14.6058 15.5625C14.6308 15.6708 14.6224 15.7687 14.5808 15.8562C14.5391 15.9437 14.4808 16.0167 14.4058 16.075C14.3308 16.1333 14.2433 16.1667 14.1433 16.175C14.0433 16.1833 13.9474 16.1583 13.8558 16.1L11.7808 14.85Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21071_258964",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187DB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21071_258964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewScans);
export default __webpack_public_path__ + "static/media/new-scans.d12d3598eaa400d793638455bec08882.svg";
export { ForwardRef as ReactComponent };